import React from 'react';
import styled from 'styled-components';

const Container = styled.div``;

const Image = styled.div`
  background: url(${props => props.bgUrl}) no-repeat center center;
  background-size: cover;
  height: 185px;
  transition: 0.2s linear;
  border-radius: 12px;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const Name = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: flex-end;
  opacity: 0;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const Char = styled.div`
  margin-top: 10px;
`;

const ImageContainer = styled.div`
  position: relative;

  &:hover {
    ${Name} {
      opacity: 1;
    }
    ${Image} {
      opacity: 0.6;
    }
  }
  @media (max-width: 768px) {
    width: 100px;
  }
`;

export const CastPage = ({ character, profile, name }) => {
  return (
    <Container>
      <ImageContainer>
        <Image
          bgUrl={
            profile
              ? `https://image.tmdb.org/t/p/original/${profile}`
              : require('../../assets/noPosterSmall.png').default
          }
        />
        <Name>{name && name}</Name>
      </ImageContainer>
      <Char>{character}</Char>
    </Container>
  );
};
